module.exports = __webpack_public_path__ + "static/media/  (159).6b856c67.jpg";